import { RequestStatusCode, REQUEST_STATUS_CODE_TO_LABEL, REQUEST_STATUS_LABEL_TO_CODE } from '../constants/RequestStatus'

/**
 * Get status label from code
 * E.g., "SUBMITTED" -> "Submitted", "SUBMITTED_ONHOLD" -> "On Hold"
 */
export const getStatusLabel = (code: string): string => {
  return REQUEST_STATUS_CODE_TO_LABEL[code as RequestStatusCode] || code
}

/**
 * Get status code from label (case-insensitive)
 * E.g., "Submitted" -> "SUBMITTED", "On Hold" -> "SUBMITTED_ONHOLD", "on Hold" -> "SUBMITTED_ONHOLD"
 */
export const getStatusCode = (label: string): RequestStatusCode | undefined => {
  // Try exact match first
  if (REQUEST_STATUS_LABEL_TO_CODE[label]) {
    return REQUEST_STATUS_LABEL_TO_CODE[label]
  }
  
  // Try case-insensitive match
  const normalizedLabel = label.toLowerCase()
  const entry = Object.entries(REQUEST_STATUS_LABEL_TO_CODE).find(
    ([key]) => key.toLowerCase() === normalizedLabel
  )
  
  return entry ? entry[1] : undefined
}
